<template>
  <div>
    <button-group
      v-model="selectedOption"
      :options="options"
      data-cy-prefix="expiration-button"
    />
    <div v-if="selectedOption === 'custom'" class="mt-5">
      <lf-input
        :placeholder="`${$t('COMMON.CUSTOM')} ${$t('COMMON.DAYS')} (1-30)`"
        :value="customDays"
        type="number"
        min="1"
        max="30"
        name="expirationDay"
        data-cy="expiration-days-input"
        class="w-full"
        no-margin
        @change="handleCustomDaysChange"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ButtonGroup, {
  type ButtonGroupOption,
} from "@/components/ui/ButtonGroup.vue";
import LfInput from "@/components/ui/inputs/LfInput.vue";

const selectedOption = defineModel<string | number>("selectedOption", {
  required: true,
});

const customDays = defineModel<number>("customDays", {
  required: true,
});

const { options } = defineProps<{
  options: ButtonGroupOption[];
}>();

const handleCustomDaysChange = (event: Event) => {
  customDays.value = Number((event.target as HTMLInputElement).value);
};
</script>
